/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import omit from 'lodash/omit';
import { AntdFormItem } from '../controlled/AntdControlledField';

const RenderGroup = ({ groupedFields = {}, meta = {} }) => {
  if (!groupedFields) return null;
  return Object.keys(groupedFields)
  .map((rowKey) => {
    const { cols = [], ...rowProps } = groupedFields[rowKey];

    return (
      <Row key={rowKey} {...rowProps}>
        {cols.map((field) => {
          const { col } = field;
          return (
            <Col
              span={24 / cols.length}
              key={Array.isArray(field.name) ? field.name.join('.') : field.name}
              {...omit(col, ['position'])}>
              <AntdFormItem field={field} key={field.name}>
                {field.render(meta)}
              </AntdFormItem>
            </Col>
          );
        })}
      </Row>
    );
  });
};
RenderGroup.propTypes = {
  groupedFields: PropTypes.object,
  meta: PropTypes.object,
};

export default RenderGroup;
